/**
 * @description 車險保障內容類型用
 */
export enum VehicleItemType {
    /** 險種-車體險 */
    ITEM_TYPE_BD = 'BD',
    /** 險種-竊盜險 */
    ITEM_TYPE_TF = 'TF',
    /** 險種-第三人責任險 */
    ITEM_TYPE_TP = 'TP',
    /** 險種-強制險 */
    ITEM_TYPE_CO = 'CO',
    /** 空行 */
    ITEM_TYPE_SEPARATOR = 'SEPARATOR',
    /** 險種主約 */
    CONTRACT_TYPE_MAIN = 'M',
    /** 險種主約附加 */
    CONTRACT_TYPE_MAIN_ADD = 'MA',
    /** 險種副約 */
    CONTRACT_TYPE_SUB = 'A',
    /** 險種副約附加 */
    CONTRACT_TYPE_SUB_ADD = 'AA',
    /** 內容型態 - 文字 */
    ITEM_OPTION_TEXT= 'TEXT',
    /** 內容型態 - 下拉選單 金額 */
    ITEM_OPTION_OPTION = 'OPTION',
    /** 內容型態 - 下拉選單 金額 */
    ITEM_OPTION_HOPTION = 'HOPTION',
    /** 內容型態 - 文字2 */
    ITEM_OPTION_CALCULATE = 'CALCULATE',
    /** 內容型態 - 計算總額 */
    ITEM_OPTION_SUM = 'SUM',
    /** FID - 下拉選單 倍數 */
    ITEM_FID_FACTOR = 'FACTOR',
    /** FID - 下拉選單 醫療 */
    ITEM_FID_MEDICAL='MEDICAL',
    /** FID - 下拉選單 身故 */
    ITEM_FID_LIFE='LIFE',
    /** FID - 下拉選單 金額 */
    ITEM_FID_AMOUNT='AMOUNT',
    // FID -自負額
    ITEM_FID_DEDUCTIBLE = 'DEDUCTIBLE',
    /** 保障項目關係-相依 */
    ITEM_RELATIVE_DEPENDENCY = 'ITEM_DEPENDENCY',
    /** 保障項目關係-互斥 */
    ITEM_RELATIVE_EXCLUDED = 'ITEM_EXCLUDED',
    /** 保障項目關係-關聯 */
    ITEM_RELATIVE_RELATED = 'ITEM_RELATED',
    /** 保障項目-附加條款 */
    ITEM_ADDITIONAL_TERM = 'ADDITIONAL_TERM',
    /** 任意險指示 */
    CV_TYPE_VI = 'VI',
    /** 強制險指示 */
    CV_TYPE_CI = 'CI'
}
